import { Button, Card, Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionRuntimeConfigs } from '../shared/SectionRuntimeConfigs';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';

const WITHDRAW_CFG_FILTER = (k: string) =>
  /withdrawal_min_threshold|daily_withdrawal_limit|high_value_review_threshold/i.test(k);
export default function BlindBoxWithdrawConfigList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-withdraw-config" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.withdrawConfig')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.withdrawConfig') },
          ]}
          action={
            <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>
              {t('module.blindBox.refreshAll')}
            </Button>
          }
        />
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <SectionRuntimeConfigs
              refreshKey={refreshKey}
              keyFilter={WITHDRAW_CFG_FILTER}
              showRewardPayoutChannel
            />
          </Card>
        </Stack>
      </DashboardContent>
    </PermissionGuard>
  );
}
